// extracted by mini-css-extract-plugin
export var configurationSection = "_tl-0";